export default __webpack_public_path__ + "static/media/ata.7a057787.svg";